var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.workWeekHandler(_vm.cellData)},[(_vm.isMidOfWeek(_vm.cellData.date))?_c('p',{staticClass:"week"},[_vm._v("KW"),_c('br'),_vm._v(_vm._s(_vm.getWorkWeek(_vm.cellData.date)))]):_vm._e(),_c('p',{staticClass:"day"},[_vm._v(_vm._s(_vm.cellData.date.getDate())+".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }